import { useState, useRef, useEffect } from "react";
import { CameraAlertRegion } from "lib/types";
import { REGION_INDEX_COLOR, CROSS_LINE_B_BG_COLOR } from "lib/constants";
const TEN_THOUSAND = 10000;
type CanvasProps = {
  canvasWidth: number;
  canvasHeight: number;
  canvasOffsetTop: number;
  canvasOffsetLeft: number;
};
const CircleRadius = 16;

function CrossLineDraw(props: {
  corssLine: CameraAlertRegion;
  ruleIndex: number;
  selected: boolean;
  updateCrossLineDetection: (points: { x: number; y: number }[]) => void;
  canvasProps: CanvasProps;
}) {
  const {
    corssLine,
    selected,
    ruleIndex,
    updateCrossLineDetection,
    canvasProps,
  } = props;

  const { canvasWidth, canvasHeight, canvasOffsetTop, canvasOffsetLeft } =
    canvasProps;

  const refRuleCanvas = useRef<HTMLCanvasElement>(null);

  const [canDraw, setCanDraw] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);

  const [regionMoving, setRegionMoving] = useState(false);
  const [startRegionMovePos, setStartRegionMovePos] = useState<{
    x: number;
    y: number;
  }>();

  const [pointMoving, setPointMoving] = useState(false);
  const [pointMovingIndex, setPointMovingIndex] = useState(-1);

  const [points, setPoints] = useState<{ x: number; y: number }[]>([]);
  const [medianPoints, setMedianPoints] = useState<{ x: number; y: number }[]>(
    [],
  );
  const [circlePoints, setCirclePoints] = useState<{ x: number; y: number }[]>(
    [],
  );
  const [cursePoint, setCursePoint] = useState<{ x: number; y: number }>();

  function transX2Canvas(x: number) {
    return Math.floor((x * canvasWidth) / TEN_THOUSAND);
  }

  function transY2Canvas(y: number) {
    return Math.floor((y * canvasHeight) / TEN_THOUSAND);
  }

  function transXFromCanvas(x: number) {
    return Math.floor((x / canvasWidth) * TEN_THOUSAND);
  }

  function transYFromCanvas(y: number) {
    return Math.floor((y / canvasHeight) * TEN_THOUSAND);
  }

  function showRule(ctx: CanvasRenderingContext2D) {
    console.log(
      "calling show rule x:",
      points[0].x,
      "y:",
      points[0].y,
      "candraw:",
      canDraw,
      cursePoint,
    );
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    console.log("line", canvasWidth, canvasHeight);

    ctx.beginPath();
    ctx.lineWidth = 2;
    let tmpX = transX2Canvas(points[0].x);
    let tmpY = transY2Canvas(points[0].y);
    ctx.moveTo(tmpX, tmpY);
    ctx.strokeStyle = REGION_INDEX_COLOR[ruleIndex];
    ctx.fillStyle = REGION_INDEX_COLOR[ruleIndex];
    for (let i = 1; i < points.length; i++) {
      tmpX = transX2Canvas(points[i].x);
      tmpY = transY2Canvas(points[i].y);

      ctx.lineTo(transX2Canvas(points[i].x), transY2Canvas(points[i].y));
    }
    if (canDraw && cursePoint) {
      ctx.lineTo(transX2Canvas(cursePoint.x), transY2Canvas(cursePoint.y));
    }
    ctx.stroke();

    ctx.beginPath();
    ctx.globalAlpha = 1;

    for (let i = 0; i < points.length && selected; i++) {
      ctx.moveTo(transX2Canvas(points[i].x), transY2Canvas(points[i].y));
      // if (i == 0 || !canDraw || i !== points.length - 1) {
      ctx.arc(
        transX2Canvas(points[i].x),
        transY2Canvas(points[i].y),
        5,
        0,
        Math.PI * 2,
      );
      // }
      ctx.lineWidth = 2;
      ctx.fillStyle = "white";
      ctx.stroke();
      ctx.fill();
    }
    ctx.closePath();
    if (points.length < 1) {
      return;
    }

    // 计算中点
    const x1 = transX2Canvas(points[0].x);
    const y1 = transY2Canvas(points[0].y);
    const endPoint = points.length > 1 ? points[1] : cursePoint;
    if (!endPoint) {
      return;
    }
    const x2 = transX2Canvas(endPoint.x);
    const y2 = transY2Canvas(endPoint.y);
    const midX = (x1 + x2) / 2;
    const midY = (y1 + y2) / 2;

    // 计算中垂线的方向

    const slope = -(x2 - x1) / (y2 - y1);
    const length = 50; // 中垂线的长度

    // 中垂线的两个端点
    const tmp = isNaN(slope * Math.sqrt(1 / (1 + slope * slope)))
      ? 1
      : slope * Math.sqrt(1 / (1 + slope * slope));
    const midX1 = midX - (length / 2) * Math.sqrt(1 / (1 + slope * slope));
    const midY1 = midY - (length / 2) * tmp;
    const midX2 = midX + (length / 2) * Math.sqrt(1 / (1 + slope * slope));
    const midY2 = midY + (length / 2) * tmp;

    console.log("midX1", midX1, midY1, tmp);
    setMedianPoints([
      { x: midX1, y: midY1 },
      { x: midX2, y: midY2 },
    ]);
    // 绘制中垂线
    ctx.beginPath();
    ctx.moveTo(midX1, midY1);
    ctx.lineTo(midX2, midY2);
    ctx.stroke();

    // 绘制箭头
    function drawArrow(toX, toY, angle) {
      const headLength = 10; // 箭头长度
      ctx.beginPath();
      ctx.moveTo(toX, toY);
      ctx.lineTo(
        toX - headLength * Math.cos(angle - Math.PI / 4),
        toY - headLength * Math.sin(angle - Math.PI / 4),
      );
      ctx.moveTo(toX, toY);
      ctx.lineTo(
        toX - headLength * Math.cos(angle + Math.PI / 4),
        toY - headLength * Math.sin(angle + Math.PI / 4),
      );
      ctx.stroke();
    }

    // 在中垂线两端绘制箭头，方向相反
    const angle1 =
      midX2 - midX1 !== 0
        ? Math.atan2(midY2 - midY1, midX2 - midX1)
        : Math.PI / 2;

    console.log("angle1", angle1);

    const vector1 = { x: x2 - x1, y: y2 - y1 };
    let vector2 = { x: midX1 - midX, y: midY1 - midY };
    console.log("corssLine?.line?.direction", corssLine);
    if (corssLine?.line?.direction === "ab") {
      drawArrow(midX1, midY1, angle1 + Math.PI); // 右侧箭头，指向右
      drawArrow(midX2, midY2, angle1); // 右侧箭头，指向右
    } else {
      if (
        (vector1.x * vector2.y - vector1.y * vector2.x > 0 &&
          corssLine?.line?.direction === "a_b") ||
        (vector1.x * vector2.y - vector1.y * vector2.x < 0 &&
          corssLine?.line?.direction === "b_a")
      ) {
        drawArrow(midX1, midY1, angle1 + Math.PI); // 右侧箭头，指向右
      } else {
        drawArrow(midX2, midY2, angle1); // 右侧箭头，指向右
      }
    }

    // 绘制圆并写字
    function drawCircleWithText(
      centerX,
      centerY,
      radius,
      text,
      color,
      bgColor,
    ) {
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
      ctx.fillStyle = bgColor;
      ctx.strokeStyle = bgColor;
      ctx.fill();

      // 绘制文本
      ctx.font = "22px Arial";
      ctx.fillStyle = color;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(text, centerX, centerY);
    }

    // 设置圆心距离箭头相同的距离
    const distanceFromArrow = 18; // 圆心距离箭头的距离

    // 计算圆心位置
    let circleX1 = midX1 - distanceFromArrow * Math.cos(angle1); // 左侧圆心
    let circleY1 = midY1 - distanceFromArrow * Math.sin(angle1);
    let circleX2 = midX2 + distanceFromArrow * Math.cos(angle1); // 右侧圆心
    let circleY2 = midY2 + distanceFromArrow * Math.sin(angle1);

    setCirclePoints([
      { x: circleX1, y: circleY1 },
      { x: circleX2, y: circleY2 },
    ]);
    vector2 = { x: circleX1 - midX, y: circleY1 - midY };
    if (vector1.x * vector2.y - vector1.y * vector2.x > 0) {
      [circleX1, circleY1, circleX2, circleY2] = [
        circleX2,
        circleY2,
        circleX1,
        circleY1,
      ];
    }
    drawCircleWithText(
      circleX1,
      circleY1,
      CircleRadius,
      "A",
      "white",
      REGION_INDEX_COLOR[ruleIndex],
    ); // 左侧圆
    drawCircleWithText(
      circleX2,
      circleY2,
      CircleRadius,
      "B",
      REGION_INDEX_COLOR[ruleIndex],
      CROSS_LINE_B_BG_COLOR[ruleIndex],
    ); // 右侧圆
    // if (vector1.x * vector2.y - vector1.y * vector2.x < 0) {
    //   drawCircleWithText(
    //     circleX1,
    //     circleY1,
    //     CircleRadius,
    //     "A",
    //     "white",
    //     REGION_INDEX_COLOR[ruleIndex],
    //   ); // 左侧圆
    //   drawCircleWithText(
    //     circleX2,
    //     circleY2,
    //     CircleRadius,
    //     "B",
    //     REGION_INDEX_COLOR[ruleIndex],
    //     CROSS_LINE_B_BG_COLOR[ruleIndex],
    //   ); // 右侧圆
    // } else {
    //   drawCircleWithText(
    //     circleX2,
    //     circleY2,
    //     CircleRadius,
    //     "A",
    //     "white",
    //     REGION_INDEX_COLOR[ruleIndex],
    //   );
    //   drawCircleWithText(
    //     circleX1,
    //     circleY1,
    //     CircleRadius,
    //     "B",
    //     REGION_INDEX_COLOR[ruleIndex],
    //     CROSS_LINE_B_BG_COLOR[ruleIndex],
    //   );
    // }

    ctx.stroke();
  }

  useEffect(() => {
    if (corssLine?.line?.startPoint && corssLine?.line?.endPoint) {
      setPoints([corssLine?.line?.startPoint, corssLine?.line?.endPoint]);
      setCanDraw(false);
    } else {
      setPoints([]);
      setCanDraw(true);
    }
  }, [corssLine]);

  useEffect(() => {
    if (canvasWidth > 0 && refRuleCanvas.current) {
      refRuleCanvas.current.width = canvasWidth;
      refRuleCanvas.current.height = canvasHeight;
      const ctx = refRuleCanvas.current.getContext("2d");
      console.log("--- points", points, "corssLine", corssLine);
      if (points?.length > 0) {
        showRule(ctx);
      } else {
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      }
    }
  }, [canvasWidth, points, cursePoint, canDraw, selected, corssLine]);

  const posOutSide = (t: number) => {
    return t < 0 || t > TEN_THOUSAND;
  };

  const handlePointMoving = (x: number, y: number) => {
    const ctx = refRuleCanvas.current.getContext("2d");
    if (regionMoving) {
      const dx = x - startRegionMovePos.x;
      const dy = y - startRegionMovePos.y;
      let xOut = false;
      let yOut = false;
      for (let i = 0; i < points.length; i++) {
        if (posOutSide(points[i].x + transXFromCanvas(dx))) {
          xOut = true;
        }
        if (posOutSide(points[i].y + transYFromCanvas(dy))) {
          yOut = true;
        }
      }
      for (let i = 0; i < points.length; i++) {
        if (!xOut) {
          points[i].x = points[i].x + transXFromCanvas(dx);
        }
        if (!yOut) {
          points[i].y = points[i].y + transYFromCanvas(dy);
        }
      }

      setPoints([...points]);
      setStartRegionMovePos({ x, y });
    } else if (pointMoving) {
      if (!posOutSide(transXFromCanvas(x))) {
        points[pointMovingIndex].x = transXFromCanvas(x);
      }
      if (!posOutSide(transYFromCanvas(y))) {
        points[pointMovingIndex].y = transYFromCanvas(y);
      }
      setPoints([...points]);
    } else {
      // just change mouse style
      if (mouseInPoints(x, y) >= 0) {
        refRuleCanvas.current.style.cursor = "Crosshair";
      } else if (mouseOnLine(x, y)) {
        refRuleCanvas.current.style.cursor = "move";
      } else {
        refRuleCanvas.current.style.cursor = "default";
      }
    }
  };

  const mouseInPoint = (
    x: number,
    y: number,
    pointX: number,
    pointY: number,
  ) => {
    if (
      Math.abs(transX2Canvas(pointX) - x) < 5 &&
      Math.abs(transY2Canvas(pointY) - y) < 5
    ) {
      return true;
    }

    return false;
  };

  const mouseInPoints = (x: number, y: number) => {
    for (let i = 0; i < points.length; i++) {
      if (mouseInPoint(x, y, points[i].x, points[i].y)) {
        return i;
      }
    }
    return -1;
  };

  function pointToLine(px, py, x1, y1, x2, y2) {
    const lineLengthSquared = (x2 - x1) ** 2 + (y2 - y1) ** 2;
    if (lineLengthSquared === 0)
      return Math.sqrt((px - x1) ** 2 + (py - y1) ** 2); // 线段退化为点

    const t =
      ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / lineLengthSquared;
    const clampedT = Math.max(0, Math.min(1, t)); // 限制 t 的值在 0 和 1 之间

    const nearestX = x1 + clampedT * (x2 - x1);
    const nearestY = y1 + clampedT * (y2 - y1);

    return Math.sqrt((px - nearestX) ** 2 + (py - nearestY) ** 2);
  }

  const mouseOnLine = (x: number, y: number) => {
    if (
      points?.length > 1 &&
      pointToLine(
        x,
        y,
        transX2Canvas(points[0].x),
        transY2Canvas(points[0].y),
        transX2Canvas(points[1].x),
        transY2Canvas(points[1].y),
      ) < 5
    ) {
      console.log(
        "mouse on points",
        pointToLine(
          x,
          y,
          transX2Canvas(points[0].x),
          transY2Canvas(points[0].y),
          transX2Canvas(points[1].x),
          transY2Canvas(points[1].y),
        ),
      );
      return true;
    }

    if (
      medianPoints?.length > 1 &&
      pointToLine(
        x,
        y,
        medianPoints[0].x,
        medianPoints[0].y,
        medianPoints[1].x,
        medianPoints[1].y,
      ) < 5
    ) {
      console.log(
        "mouse on medianPoints",
        pointToLine(
          x,
          y,
          medianPoints[0].x,
          medianPoints[0].y,
          medianPoints[1].x,
          medianPoints[1].y,
        ),
      );
      return true;
    }

    for (let i = 0; i < circlePoints.length; i++) {
      const distance = Math.sqrt(
        (x - circlePoints[i].x) ** 2 + (y - circlePoints[i].y) ** 2,
      );
      console.log("distance", distance, CircleRadius);
      if (distance <= CircleRadius) {
        return true;
      }
    }
    return false;
  };

  const onMouseMove = (e: any) => {
    console.log("onMouseMove");
    if (!selected) {
      return;
    }
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    if (canDraw) {
      if (isDrawing) {
        const correctX = Math.max(
          0,
          Math.min(TEN_THOUSAND, transXFromCanvas(x)),
        );
        const correctY = Math.max(
          0,
          Math.min(TEN_THOUSAND, transYFromCanvas(y)),
        );

        setCursePoint({ x: correctX, y: correctY });
      } else {
        // refRuleCanvas.current.style.cursor = 'Crosshair';
      }
    } else {
      handlePointMoving(x, y);
    }
  };

  const onMouseDown = (e: any) => {
    if (!selected) {
      return;
    }
    if (canDraw) {
      return;
    }
    console.log("onMouseDown");
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const ctx = refRuleCanvas.current.getContext("2d");
    const index = mouseInPoints(x, y);
    if (index >= 0) {
      setPointMoving(true);
      setPointMovingIndex(index);
    } else if (mouseOnLine(x, y)) {
      console.log("setRegionMoving");
      setRegionMoving(true);
      setStartRegionMovePos({ x, y });
    }
  };

  const onMouseUp = (e: any) => {
    if (!selected) {
      return;
    }
    if (canDraw) {
      const rect = e.target.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      console.log("mouse up");
      setIsDrawing(true);
      // points.pop();
      if (points.length > 2) return;
      const newPoints = [
        ...points,
        { x: transXFromCanvas(x), y: transYFromCanvas(y) },
      ];
      setPoints(newPoints);

      if (newPoints?.length == 2) {
        // end drawing while mouse up on the first point
        console.log("end drawing");
        setCanDraw(false);
        setIsDrawing(false);
        updateCrossLineDetection(newPoints);
      }
    } else {
      if (regionMoving || pointMoving) {
        updateCrossLineDetection(points);
        setRegionMoving(false);
        setPointMoving(false);
      }
    }
  };

  const onDoubleClick = (e: any) => {
    if (!selected) {
      return;
    }
    if (!isDrawing) {
      return;
    }
    console.log("mouse onDoubleClick");
    setCanDraw(false);
    setIsDrawing(false);
    updateCrossLineDetection(points);
  };

  return (
    <div
      className="absolute "
      style={{
        width: canvasWidth,
        height: canvasHeight,
        top: canvasOffsetTop,
        left: canvasOffsetLeft,
        zIndex: selected ? 11 : 10,
      }}
      onMouseMove={onMouseMove}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onDoubleClick={onDoubleClick}
    >
      <canvas ref={refRuleCanvas} />
    </div>
  );
}

export default CrossLineDraw;
